import { Typography } from '@mui/material';

import React from 'react';

export interface SlideTitleProps {
  readonly children: React.ReactNode;
  style?: React.CSSProperties;
}

export function SlideTitle({
  children,
  style,
}: SlideTitleProps): React.ReactElement {
  return (
    <Typography
      sx={{
        color: '#004F7E',
        fontFamily: 'Roboto',
        fontWeight: '600',
        fontSize: '38px',
        ...style,
      }}
    >
      {children}
    </Typography>
  );
}
